import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import React from 'react'
import { QueryClientProvider } from 'react-query'
import { HashRouter } from 'react-router'

import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'
import { UserUmbrellasContextProvider } from '@modules-deprecated/app/umbrellas'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import { SignupGuide } from '@views/signupGuide'
import { EmberActionPayload, SignupGuideContextProvider } from '@views/signupGuide/context/signupGuideContext'

import { queryClient } from '../../config/queryClient'
import { EmberNavigate, EmberRouterContextProvider } from '../../contexts/emberRouterContext'
import { ThemeProvider } from '../../contexts/themeProvider'

const MODULE_NAME = 'signup-guide-module'

class SigupModel extends DOMModel {
  @byAttrVal locale: string
  @byAttrVal organizationId: string
  @byAttrVal routeUmbrellaId: string
  @byAttrVal signupCouponParams: string
  @byAttrVal signupUmbrellaId: string
  @byAttrVal userEmail: string
  @byAttrVal userId: string
  @byAttrVal userName: string
  @registerEvent('authorizeUser') authorizeUser: Function
  @registerEvent('changeLocale') changeLocale: Function
  @registerEvent('navigate') navigate: Function
  @registerEvent('registerOrganization') registerOrganization: Function
}

interface SignupGuideModuleProps {
  crateOrganizationDescription?: string
  crateOrganizationTitle?: string
  locale?: string
  onAuthorizeUser: (payload: EmberActionPayload) => void
  onChangeLocale: (paylod: EmberActionPayload) => void
  onNavigate: EmberNavigate
  onRegisterOrganization: (payload: EmberActionPayload) => void
  organizationId?: string
  routeUmbrellaId?: string
  signupCouponParams?: string
  signupUmbrellaId?: string
  userEmail?: string
  userId?: string
  userName?: string
}

const SignupGuideModule = ({
  locale,
  onAuthorizeUser,
  onChangeLocale,
  onNavigate,
  onRegisterOrganization,
  organizationId,
  routeUmbrellaId,
  signupCouponParams,
  signupUmbrellaId,
  userEmail,
  userId,
  userName,
}: SignupGuideModuleProps) => (
  <QueryClientProvider client={queryClient}>
    <EmberRouterContextProvider onNavigate={onNavigate}>
      <ThemeProvider>
        <HashRouter>
          <UserUmbrellasContextProvider>
            <SignupGuideContextProvider
              locale={locale}
              onAuthorizeUser={onAuthorizeUser}
              onChangeLocale={onChangeLocale}
              onRegisterOrganization={onRegisterOrganization}
              routeUmbrellaId={routeUmbrellaId}
              signupCouponParams={signupCouponParams}
              signupUmbrellaId={signupUmbrellaId}
              userEmail={userEmail}
              userId={userId}
              userName={userName}
            >
              <UserOrganizationContextProvider organizationId={organizationId}>
                <CurrentUserContextProvider enabled={false}>
                  <SignupGuide />
                </CurrentUserContextProvider>
              </UserOrganizationContextProvider>
            </SignupGuideContextProvider>
          </UserUmbrellasContextProvider>
        </HashRouter>
      </ThemeProvider>
    </EmberRouterContextProvider>
  </QueryClientProvider>
)

const SignupElement = createCustomElement(SignupGuideModule, SigupModel, 'element')

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, SignupElement)

export default SignupElement
